import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import api from "@/lib/api";
import { Loader2, AlertCircle, UserCog, Building2, MapPin } from "lucide-react";

export default function LandlordDashboard() {
  const [prof, setProf] = useState(null);
  const [props, setProps] = useState([]);

  useEffect(() => {
    api.get("/landlord/profile").then(({ data }) => setProf(data)).catch(() => setProf(false));
    api.get("/landlord/properties").then(({ data }) => setProps(data)).catch(() => setProps([]));
  }, []);

  if (prof === null) return <div className="flex justify-center py-20"><Loader2 className="w-6 h-6 animate-spin text-brand" /></div>;

  const isCorp = prof && prof.account_type === "corporate";
  const reqInd = ["name", "name_kana", "phone", "email", "postal_code", "prefecture", "city", "address_line"];
  const reqCorp = ["company_name", "corporate_kind", "postal_code", "prefecture", "city", "address_line", "phone", "email"];
  const req = isCorp ? reqCorp : reqInd;
  const missing = prof ? req.filter((k) => !prof[k]).length : 0;

  return (
    <div className="animate-fade-in" data-testid="landlord-dashboard">
      <h1 className="font-display text-2xl font-light mb-1">貸主ポータル</h1>
      <p className="text-sm text-gray-400 mb-6">貸主情報の登録・所有物件の確認ができます。</p>

      {prof && missing > 0 && (
        <div className="mb-6 rounded-lg border border-amber-500/30 bg-amber-500/10 p-4" data-testid="landlord-profile-alert">
          <div className="flex items-start gap-3">
            <AlertCircle className="w-5 h-5 text-amber-400 shrink-0 mt-0.5" />
            <div className="flex-1">
              <div className="text-sm font-medium text-amber-200">貸主情報の入力が完了していません</div>
              <div className="text-xs text-amber-100/80 mt-1">未入力の必須項目が {missing} 件あります。</div>
              <Link to="/landlord/profile" className="inline-flex items-center gap-1.5 mt-3 bg-amber-500 hover:bg-amber-600 text-black text-sm font-medium rounded-md px-4 py-2 transition-colors" data-testid="landlord-profile-alert-cta">
                <UserCog className="w-4 h-4" />プロフィールを入力する
              </Link>
            </div>
          </div>
        </div>
      )}

      <div className="bg-[#161616] border border-white/5 rounded-lg p-5">
        <h3 className="text-sm font-medium mb-3 flex items-center gap-1.5"><Building2 className="w-4 h-4 text-brand" />所有物件（{props.length}件）</h3>
        {props.length === 0 ? (
          <p className="text-sm text-gray-500">現在、割り当てられた物件はありません。</p>
        ) : (
          <div className="space-y-2">
            {props.map((p) => (
              <div key={p.id} className="flex items-center justify-between border border-white/5 rounded-md px-4 py-3" data-testid={`landlord-property-${p.id}`}>
                <div>
                  <div className="text-sm font-medium">{p.name}</div>
                  <div className="text-xs text-gray-500 flex items-center gap-1 mt-0.5"><MapPin className="w-3 h-3" />{p.address || "-"}</div>
                </div>
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
}
